import {
  getAllModulesInitActions,
  getSectionLayoutInitAction,
  getPageInfoInitActions,
} from './common';

export function getPostsSectionInitActions(responseData, requestParams) {
  return [
    getSectionLayoutInitAction(responseData, 'posts'),
    ...getPageInfoInitActions(responseData, requestParams),
    ...getAllModulesInitActions(responseData, requestParams),
  ].filter(action => action);
}
